import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ExitToApp } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useGetListQuery } from '../../services/TMDB';
import RatedCard from '../RatedCard/RatedCard';
const Profile = () => {
  const dispatch = useDispatch();
 
  const { user } = useSelector((state) => state.user);
  
  // Get Favourite Movies through redux if it exists
  const { data: favoriteMovies, refetch:refetchFavorite  } = useGetListQuery({ listName: 'favorite/movies', accountId: user.id, sessionId: localStorage.getItem("session_id"), page: 1 })
    
  // Get Watchlist Movies through redux if it exists
  const { data: watchlistMovies,  refetch:refetchWatchlist } = useGetListQuery({ listName: 'watchlist/movies', accountId: user.id, sessionId: localStorage.getItem("session_id"), page: 1 });;
    
  useEffect(() => {

    refetchFavorite();
    refetchWatchlist();
  }, [])
  
  // console.log('user', user);
  const logout = () => {
    localStorage.clear();
    window.location.href = '/';
  }
  return (
    <div>
      <Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant='h4' gutterBottom>My Profile</Typography>
          <Button color='inherit' onClick={logout}>Logout &nbsp; <ExitToApp /> </Button>
        </Box>

        {favoriteMovies ?  
          <RatedCard title="Favorited Movies" movies={favoriteMovies} /> : (
          <Typography variant='h5'>Add Favourites or watchlist some movies to see them here </Typography> 
          )}
        
        {watchlistMovies ?  
          <RatedCard title="WatchList Movies" movies={watchlistMovies} /> : (
          <Typography variant='h5'>Add Favourites or watchlist some movies to see them here </Typography> 
        )}
      </Box>
    </div>
  )
}

export default Profile